import { nakshatraLords, getNakshatraColor } from "../../utils/astroUtils";
import { useLanguage } from "../../context/LanguageContext";

const ClockLabels = ({ center, radius }) => {
  const { t } = useLanguage();
  const nakshatraNames = Object.keys(nakshatraLords);
  const totalNakshatras = nakshatraNames.length;
  const anglePerNakshatra = 360 / totalNakshatras;
  const labelRadius = radius + 25; // assuming you already increased this

  return (
    <g>
      {nakshatraNames.map((nakshatra, i) => {
        const startAngle = i * anglePerNakshatra;
        const endAngle = startAngle + anglePerNakshatra;
        const midAngle = (startAngle + endAngle) / 2;

        const radians = (midAngle - 90) * (Math.PI / 180);
        const textX = center + labelRadius * Math.cos(radians);
        const textY = center + labelRadius * Math.sin(radians);

        const nameParts = t(nakshatra).split(" ");

        return (
          <text
            key={`label-${i}`}
            x={textX}
            y={textY}
            fontSize="12"
            fill={getNakshatraColor(nakshatra)}
            fontWeight="normal"
            textAnchor="middle"
            dominantBaseline="middle"
            transform={`rotate(${midAngle}, ${textX}, ${textY})`}
            stroke="none"
            strokeWidth="0.75"
            style={{
              pointerEvents: "none",
              // textShadow removed to eliminate glow
            }}
          >
            {nameParts.map((part, idx) => (
              <tspan key={idx} x={textX} dy={idx === 0 ? "0" : "1.1em"}>
                {part}
              </tspan>
            ))}
          </text>
        );
      })}
    </g>
  );
};

export default ClockLabels;
